export default __webpack_public_path__ + "static/media/borderless-phone.10d6b531.svg";